const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const Link = require("./Link");
const AssetsUtil = require("../util/AssetsUtil");
const BeastBuilderShared = require("../../../shared/BeastBuilderShared");

const styles = require("./styles/Avatar.css");

module.exports = createReactClass({
	displayName: "Avatar",

	propTypes: {
		avatar: PT.object.isRequired,
		style: PT.object,
		className: PT.string.isRequired,
		hasSurround: PT.bool,
		surroundColor: PT.string,
		hasRing: PT.bool, //cannot be true if hasSurround is true
		ringSize: PT.number, //Size in pixels of the ring
		backgroundType: PT.oneOf(["default", "opaque", "hidden"]),
		// If avatar isn't chosen yet, fallbackDisplayName is used to display
		// the first letter of the display name instead.
		fallbackDisplayName: PT.string,
		//If the contents (background/img) should be replaced by another image
		//set avatarReplacementImgSrc.
		avatarReplacementImgSrc: PT.string,
		useWonkyCursor: PT.bool,
		linkTo: PT.string,
		linkClickAction: PT.func,
		clickThrough: PT.bool,
	},

	getInitialState: function() {
		return {
			imageHasErrored: false,
			fallbackImgSrc: null,
		};
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		if (
			nextProps.avatarReplacementImgSrc !==
				this.props.avatarReplacementImgSrc ||
			!_.isEqual(nextProps.avatar, this.props.avatar)
		) {
			this.setState({
				imageHasErrored: false,
				fallbackImgSrc: null,
			});
		}
	},

	getDefaultProps: function() {
		return {
			ringSize: 2,
			backgroundType: "default",
		};
	},

	getRef: function() {
		return this.avatar;
	},

	onImageError: function() {
		if (!this.state.imageHasErrored) {
			this.setState({
				imageHasErrored: true,
				fallbackImgSrc: "https://beastacademy.com/public/beast/1-default.jpeg",
			});
		}
	},

	render: function() {
		const {
			avatar,
			style,
			className,
			linkTo,
			hasSurround,
			hasRing,
			ringSize,
			backgroundType,
			linkClickAction,
			surroundColor,
			fallbackDisplayName,
			avatarReplacementImgSrc,
			useWonkyCursor,
		} = this.props;
		let surround = null;
		if (hasSurround) {
			surround = (
				<img
					className={styles.main}
					src={AssetsUtil.getButton("surround", surroundColor)}
				/>
			);
		} else if (hasRing) {
			const ringStyle = {
				borderWidth: `${ringSize}px`,
			};
			surround = <div className={styles.ring} style={ringStyle} />;
		}

		let linkDiv = null;
		if (linkTo) {
			linkDiv = (
				<Link
					to={linkTo}
					className={styles.link}
					clickAction={linkClickAction}
					useWonkyCursor={useWonkyCursor}
				/>
			);
		}

		let imgSrc;
		let img;
		let imgClass = styles.main;

		if (avatarReplacementImgSrc) {
			imgSrc = avatarReplacementImgSrc;
			imgClass += " " + styles.bg;
		} else if (_.isEmpty(avatar) && fallbackDisplayName) {
			const firstLetter = _.toUpper(fallbackDisplayName.charAt(0));
			let color;
			const textStyle = {fill: color};
			img = (
				<svg className={styles.letterImg} viewBox="0 0 100 100">
					<text
						fontSize="80"
						style={textStyle}
						textAnchor="middle"
						x="50"
						y="80"
					>
						{firstLetter}
					</text>
				</svg>
			);
		} else {
			imgSrc =
				BeastBuilderShared.getAvatarURL(avatar) ||
				BeastBuilderShared.getAvatarURL({num: 1});
		}

		if (this.state.fallbackImgSrc && !avatarReplacementImgSrc) {
			imgSrc = this.state.fallbackImgSrc;
		}

		if (!img) {
			img = imgSrc ? (
				<img className={imgClass} src={imgSrc} onError={this.onImageError} />
			) : null;
		}

		const backgroundColor = _.get(avatar, "color", "#FFFFFF");
		const bgType = _.camelCase(`bg ${backgroundType}`);
		return (
			<div
				ref={a => (this.avatar = a)}
				style={style}
				className={`${styles.wrapper} ${className} ${
					this.props.clickThrough ? styles.clickThrough : ""
				}`}
			>
				<div
					className={`${styles.bg} ${styles[bgType]}`}
					style={{backgroundColor}}
				/>
				{img}
				{surround}
				{linkDiv}
			</div>
		);
	},
});
